import { axiosInstance } from '../Config/axios';

const API_URL = 'v1/gaps/';
const API_URL_TEMPLATE_GAPS = 'v1/gaps_template/';
const API_DELETED_URL = 'v1/gaps-deleted/';
const ISSUE_URL = 'v1/gaps/issues/';

// Obtener todos los GAPs
export const getGaps = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    console.error("Error al obtener todos los GAPs:", error);
    throw error;
  }
};

// Obtener template asignaciones para asignar controles
export const getGapsTemplate = async () => {
  try {
    const response = await axiosInstance.get(API_URL_TEMPLATE_GAPS);
    return response.data;
  } catch (error) {
    console.error("Error al obtener el template de gaps:", error);
    throw error;
  }
};

// Obtener un GAP específico por código
export const getGapsByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el GAP con código ${code}:`, error);
    throw error;
  }
};

// Obtener una ISSUE específica por código
export const getIssueByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${ISSUE_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener la issue", error);
    throw error;
  }
};

// Actualizar una ISSUE por código
export const updateIssueByCode = async (code, data) => {
  try {
    const response = await axiosInstance.put(`${ISSUE_URL}${code}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar la issue con código ${code}:`, error);
    throw error;
  }
};

// Crear comentario de una ISSUE
export const createComment = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}issue/comment/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al crear el comentario de una issue`, error);
    throw error;
  }
};

// Obtener status de la issue
export const getIssueStatus = async () => {
  try {
    const response = await axiosInstance.get(`${ISSUE_URL}config/status/`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener el status de la issue", error);
    throw error;
  }
};

// Tareas

// Crear tarea de una ISSUE
export const createTask = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}issue/task/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al crear la tarea de una issue`, error);
    throw error;
  }
};

// Actualizar tarea de una ISSUE
export const updateTask = async (taskId, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}issue/task/${taskId}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar la tarea de una issue`, error);
    throw error;
  }
};

// Eliminar tarea de una ISSUE
export const deleteTask = async (code, data) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}issue/task/${code}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar la tarea de una issue`, error);
    throw error;
  }
};

// Obtener una TASK específica por código
/* export const getTaskByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_URL}issue/task/10/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener la dependencia con código 10:`, error);
    throw error;
  }
}; */

// Función para listar los gaps eliminados (GET)
export const getGapsDeleted = async () => {
  try {
    const response = await axiosInstance.get(API_DELETED_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los gaps eliminados:', error);
    throw error;
  }
};

// Obtener una gap eliminado por código (GET)
export const getGapsDeletedByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_DELETED_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el gap eliminado con código ${code}:`, error);
    throw error;
  }
};

// Función para listar las issues eliminados (GET)
export const getIssuesDeleted = async () => {
  try {
    const response = await axiosInstance.get(API_DELETED_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los issues eliminados:', error);
    throw error;
  }
};

// Obtener una gap eliminado por código (GET)
export const getIssuesDeletedByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_DELETED_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el issue eliminado con código ${code}:`, error);
    throw error;
  }
};